import React from 'react';
import { InputContainer } from '../../../../../../common/components/form/form.module';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';

export const ProgramBasicInfoComponent = ({ onInnerBasicFormChange,ProgramType,ONEProgramType,selectedPrograms, shippingProviders }: any) => {
    return (
        <><AccordionContainer
            child={
                <div className=' grid md:grid-cols-3 lg:grid-cols-3 gap-4'>
                    <InputContainer

                        label="Enable"
                        name="IsEnabled"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event,
                                'IsEnabled'
                            )
                        }}
                        type="checkbox"
                        value={selectedPrograms?.IsEnabled}
                    />


                    <InputContainer

                        label="Active"
                        name="IsActive"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event,
                                'IsActive'
                            )
                        }}
                        type="checkbox"
                        value={selectedPrograms?.IsActive}
                    />

                    <InputContainer
                        label="Program Type"
                        labelField="Description"
                        list={ProgramType}
                        onValueChange={(event: any, newValue: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'ProgramTypeId',
                            );
                        }}
                        optionName='Choose training'
                        type="select"
                        value={selectedPrograms?.ProgramTypeId}
                        valueField="Value"
                    />

                    <InputContainer
                        label="Name"
                        name="Name"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Name'

                            )
                        }}
                        type="text"
                        value={selectedPrograms?.Name}
                    />

                    <InputContainer
                        label="Start Date"
                        name="StartDateUtc"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'StartDateUtc'
                            )
                        }}
                        type="date"
                        value={selectedPrograms?.StartDateUtc}
                    />

                    <InputContainer
                        label="End Date"
                        name="EndDateUtc"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'EndDateUtc'
                            )
                        }}
                        type="date"
                        value={selectedPrograms?.EndDateUtc}
                    />


                    <InputContainer
                        label="Description"
                        name="Description"
                        onValueChange={(event: any) => {
                            onInnerBasicFormChange(
                                event.target.value,
                                'Description'

                            )
                        }}
                        type="text"
                        value={selectedPrograms?.Description}
                    />

                </div>
            }
            expandedPanel="Basic Info"
            headerTitle="Basic Info"
        />
        </>

    )
}
export default ProgramBasicInfoComponent;
